import styleToSelector from 'amkit3-modules/utils/style-to-selector'

let selector = styleToSelector(require('./style.scssm'))

module.exports = selector
